'use strict';
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('TiposOcorrenciasCtrl', function($scope, $rootScope, $q, $route, $location,
  $routeParams, $window, Flash, TiposOcorrenciasService, LoadingService, MessagesService) {
  $rootScope.bodyClass = 'list-filter-body';
  $scope.tiposDeOcorrencia = TIPOS_OCORRENCIA;

  const initializeVariables = function() {
    $scope.filters = {
      exibir: 'ativos'
    };
    $scope.tiposOcorrencias = null;
    $scope.tipoOcorrencia = null;
    $scope.pages = {};
  };

  const initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.tipos_ocorrencia.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }
      initializeVariables();
      $scope.buscarClick();
    }, $rootScope.errorRootInitialize);
  };

  $scope.getTiposOcorrencias = function() {
    LoadingService.showLoading();
    $scope.tiposOcorrencias = null;

    TiposOcorrenciasService.list($scope.filters).then(function(data) {
      $scope.tiposOcorrencias = data.data || [];
      $scope.pages = data.pages || {};
    }, function() {
      MessagesService.alert('Não foi possível buscar os Tipos de Ocorrências.');
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.setPage = function(page) {
    const isEqual = $scope.filters.page && $scope.filters.page === page;
    if ((typeof(page) === 'undefined') || (!$scope.filters.page && page === 1) || isEqual) {
      return;
    }
    $scope.filters.page = page;
    $scope.getTiposOcorrencias();
  };

  $scope.buscarClick = function() {
    $scope.filters.page = null;
    $scope.getTiposOcorrencias();
  };

  $scope.new = function() {
    openSideEdition();
  };

  $scope.edit = function(tipoOcorrencia) {
    openSideEdition(tipoOcorrencia);
  };

  function openSideEdition(tipoOcorrencia) {
    const params = {
      id: (tipoOcorrencia || {}).id
    };

    $scope.openedTipoOcorrencia = true;
    $scope.$broadcast('activeTipoOcorrencia', params);
  }

  $scope.ocorrenciaClassName = function(type) {
    return `ocorrencia-type-${type}`;
  };

  $scope.toggleTipo = function(tipo) {
    LoadingService.showLoading();
    if (tipo.ativo) {
      $scope.deleteTipo(tipo);
    } else {
      TiposOcorrenciasService.restoreTipo(tipo)
        .then(function() {
          MessagesService.alert('Tipo ativado com sucesso');
          $scope.getTiposOcorrencias();
        })
        .catch(function(error) {
          console.error(`Error ao ativar ${tipo.descricao}`, error);
          MessagesService.alert('Erro ao ativar tipo de ocorrência');
        })
        .finally(LoadingService.hideLoading);
    }
  };

  $scope.deleteTipo = function(tipo) {
    MessagesService.confirm(`Você tem certeza que deseja inativar ${tipo.descricao}?`)
      .then(function() {
        TiposOcorrenciasService.deleteTipo(tipo)
          .then(function() {
            MessagesService.alert('Tipo inativado com sucesso!');
            $scope.getTiposOcorrencias();
          })
          .catch(function(error) {
            console.error(`Error ao inativar ${tipo.descricao}`, error);
            //eslint-disable-next-line
          if (typeof(error) !== typeof(undefined)) {
              MessagesService.alert('Erro ao atualizar tipo');
            }
          })
          .finally(LoadingService.hideLoading);
      });
  };

  $scope.$on('deactiveTipoOcorrencia', function() {
    $scope.openedTipoOcorrencia = false;
  });

  initialize();
});
